import { MAX_COL, ratioByCol } from './constants'
import { MultipleBanner } from './index.types'

export const configGrid = (
  listLength: number,
  layout: MultipleBanner['layout'],
) => {
  const colNumber = Math.min(listLength, MAX_COL)
  return {
    grow: listLength < MAX_COL,
    span: colNumber ? 3 : 12 / listLength,
    ratio: ratioByCol[layout][colNumber],
    gap: 24,
    smGap: 16,
  }
}
